export default "__VITE_PUBLIC_ASSET__78039093__"